import { isFinanceProject, isGlobalProject } from 'config';

export const getLegalClientClassificationFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return ['general', 'activityTypes', 'OKPOCode'];
  }

  if (isGlobalProject()) {
    return ['general', 'activityTypes', 'OKPOCode', 'companyActivity'];
  }

  return [];
};
